import _ from "lodash";
import { takeLatest, call, put } from "redux-saga/effects";
import { exportCommentsAndResponsesToExcel } from "../../../services/comments";
import * as actions from "../commentActions";
import { downloadExcelFile } from "../../../utilities/downloadUtils";

export default function* exportCommentsToExcelWatcher() {
  yield takeLatest(
    actions.EXPORT_COMMENTS_TO_EXCEL,
    exportCommentsToExcelWorker,
  );
}

export function* exportCommentsToExcelWorker(action) {
  try {
    const response = yield call(exportCommentsAndResponsesToExcel, { closingId: action.closingId, docCategoryId: action.docCategoryId });
    const exportedFileContent = _.get(
      response,
      "data.exportCommentsAndResponsesToExcel",
      null,
    );
    if (exportedFileContent) {
      const dateStamp = new Date().toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }).replace(/\//g, "-");
      yield call(downloadExcelFile, { fileContent: exportedFileContent, fileName: `Comment_${dateStamp}.xlsx` });
      yield put(actions.exportCommentsToExcelSuccess());
    } else {
      yield call(handleExportFailure, 'Unable to export comments. Please try again later.');
    }
  } catch (error) {
    yield call(handleExportFailure, 'Unable to export comments. Please try again later.');
  }
}

export function* handleExportFailure(error) {
  const message = typeof error === 'string' ? error : error?.message ?? 'An error occurred while exporting comments';
  yield put(actions.exportCommentsToExcelFailure(message));
}
